export const revenueApiPath = {
  getMonthlyRevenue: '/v2/revenue/monthly',
} as const;
